import ResumeDistributionBanner from './ResumeDistributionBanner'
export default ResumeDistributionBanner
